export const PlayIcon = ({ width = 15, height = 20, color = '#FAFAFB', ...props }: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 15 20' fill='none' {...props}>
    <path
      d='M13.7519 9.16795C14.3457 9.56377 14.3457 10.4362 13.7519 10.832L1.5547 18.9635C0.890143 19.4066 1.2621e-07 18.9302 1.61122e-07 18.1315L8.71999e-07 1.86852C9.06911e-07 1.06982 0.890146 0.59343 1.5547 1.03647L13.7519 9.16795Z'
      fill={color}
    />
  </svg>
);
